import { BaseApi } from "../BaseApi";
import { AuthDataProps, LoginFormProps } from "./AuthDTO";

export class AuthApi extends BaseApi {
  public login(values: Omit<LoginFormProps, "remember">): Promise<AuthDataProps> {
    return this.post("authentication_token", { json: values });
  }
}
